

import WebPagesStats from '@/pages/content/WebPagesStats';
import WebPagesTable from '@/pages/content/WebPagesTable';


const Content: React.FC = () => {
  

    return (
        <div>
            <WebPagesStats />
            <WebPagesTable />
         
        </div>
    );
};

export default Content;
